import { useQuery } from '@tanstack/react-query';

import { analyticsTypes } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

export const getPostReactors: analyticsTypes.GetPostReactors = ({ postId }) => {
  return axios.get(`/analytics/posts/${postId}/reactors`);
};

type QueryFnType = typeof getPostReactors;

export const useGetPostReactors = ({
  config = {},
  postId,
}: {
  postId: string;
  config?: QueryConfig<QueryFnType>;
}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['instagram-post-reactors', postId],
    queryFn: () => getPostReactors({ postId }),
  });
};
